import { Renta } from 'src/gql/schema'
import Detail from 'src/shared/components/data-display/Detail/Detail'
import DetailAction from 'src/shared/components/data-display/Detail/kit/DetailAction/DetailAction'
import DetailContent from 'src/shared/components/data-display/Detail/kit/DetailContent/DetailContent'
import DetailIcon from 'src/shared/components/data-display/Detail/kit/DetailIcon/DetailIcon'
import DetailRow from 'src/shared/components/data-display/Detail/kit/DetailRow/DetailRow'
import DetailText from 'src/shared/components/data-display/Detail/kit/DetailText/DetailText'
import { RoleNames } from 'src/shared/hooks/useAuth'
import { useProfile } from 'src/shared/hooks/useProfile'

const TipoEntrada = ({ ultima_renta, onAction, matricula, marca, color, modelo }: { ultima_renta: Renta, onAction: () => void, matricula: string, marca: string, color: string, modelo: string }) => {

    const { rolName } = useProfile()
    const isMantenimiento = rolName === RoleNames.mantenimiento

    return (
        <Detail color="white">
            <DetailIcon name={ultima_renta?.tipo_entrada === "A_Pie" ? "walking" : "car"} />
            <DetailContent>
                <DetailRow>
                    <DetailText type="normal">
                        Tipo de entrada
                    </DetailText>
                    {
                        !isMantenimiento && rolName !== RoleNames.monitoreo &&
                        <DetailAction onClick={onAction}>
                            Editar
                        </DetailAction>
                    }
                </DetailRow>
                <DetailRow>
                    <DetailText type="bold">
                        {ultima_renta?.tipo_entrada === "A_Pie"
                            ? "A pie"
                            : [matricula, marca, color, modelo].filter(Boolean).join(" / ")}
                    </DetailText>
                </DetailRow>
            </DetailContent>
        </Detail>
    )
}

export default TipoEntrada
